<template>
  <div id="app" class="site container hfeed" style="height: auto !important">
    <HeadNav selectedLanguage="en" page="download" />

    <div id="content" class="main-wrapper" style="height: auto !important;">
      <div class="top">
        <img src="@/assets/1.webp" alt="logo">
        <div class="right">
          <h1>
            Download GB WhatsApp APK File (Latest Version )
</h1>
          <div class="label">
            <span
              style="display:inline-block; background-color:#a6c2e0; color:#fff; padding:8px 16px; border-radius:16px; font-size:16px; font-weight:bold; margin-right:10px;">
              Anti-Ban
            </span>
            <span
              style="display:inline-block; background-color:#a6c2e0; color:#fff; padding:8px 16px; border-radius:16px; font-size:16px; font-weight:bold; margin-right:10px;">
              Multi gif providers
            </span>
            <span
              style="display:inline-block; background-color:#a6c2e0; color:#fff; padding:8px 16px; border-radius:16px; font-size:16px; font-weight:bold;">
              Dark mode
            </span>
          </div>

          <DownloadBtn value="Download APK File" style="margin-top: 50px;" />
        </div>
</div>

      <p>
Download the <strong>latest GB WhatsApp APK 2026</strong> securely — our trusted source for verified, updated,
        and malware-free APK files. Unlock powerful privacy controls, anti-ban protection, custom themes, and an
        upgraded messaging experience designed exclusively for Android users.
</p>

      <hh2><strong>GB</strong> <strong>WhatsApp App Info</strong></hh2>
      <ul>
        <li><strong>App Name:</strong> GB WhatsApp</li>
        <li><strong>Version:</strong> v18.80</li>
        <li><strong>File Size:</strong> 65 MB</li>
        <li><strong>Last Updated:</strong> Today</li>
        <li><strong>Android Requirement:</strong> Android 5.0 and above</li>
        <li><strong>Developer:</strong> Independent Mod Developer</li>
      </ul>

      <hh2>GB WhatsApp Download and Installation Guide</hh2>
      <p>
GB WhatsApp is a modified version of WhatsApp that offers additional privacy settings and customization
        options, designed for Android devices. Follow these steps to safely download and install GB WhatsApp:
</p>

      <hh3>Step 1: Download GB WhatsApp APK</hh3>
      <ul>
        <li>Visit a <strong>trusted website</strong> to download the APK file safely.</li>
        <li>Download the latest version of GB WhatsApp (e.g., v18.80).</li>
        <li>The file size is usually around 60–70 MB, suitable for most Android devices.</li>
      </ul>

      <hh3>Step 2: Enable Unknown Sources</hh3>
      <ul>
        <li>Go to <strong>Settings → Security</strong> on your Android device.</li>
        <li>Enable <strong>“Install from Unknown Sources”</strong>.</li>
        <li>This allows you to install APK files downloaded from browsers or third-party websites.</li>
      </ul>

      <hh3>Step 3: Install GB WhatsApp</hh3>
      <ul>
        <li>Locate the downloaded APK file and tap to install.</li>
        <li>Follow the on-screen instructions to complete the installation.</li>
        <li>Once installed, open the app.</li>
      </ul>

      <hh3>Step 4: Verify Your Phone Number</hh3>
      <ul>
        <li>Enter the phone number you want to use with GB WhatsApp.</li>
        <li>Verify using the code sent via SMS.</li>
        <li>If you have a previous WhatsApp backup, you can choose to <strong>restore chats</strong>.</li>
      </ul>

      <hh3>Step 5: Setup and Use</hh3>
      <ul>
        <li>
After installation, customize your app with <strong>privacy settings, themes, and chat layouts</strong>.
        </li>
        <li>
If you want to use both official WhatsApp and GB WhatsApp on the same device, make sure to use
          <strong>different phone numbers</strong>.
</li>
      </ul>

      <hh3>Safety Tips</hh3>
      <ul>
        <li>Always download GB WhatsApp from a <strong>trusted source</strong>.</li>
        <li>Keep the app updated for security and stability.</li>
        <li>Avoid installing APK</li>
      </ul>
</div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';
import DownloadBtn from '@/components/DownloadBtn.vue';

export default {
  name: 'Download',
  components: {
    HeadNav, DownloadBtn
  },
  data() {
    return {
      pageName: 'download',
      showapk: false,

      // 下载页固定使用最新 APK
      apk: 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.27.910_gw.apk',
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  mounted() {
    this.apk = 'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.27.910_gw.apk';
  },
  methods: {
    downloadfrom(reason) {
      // this.download();
      // this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    download() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
    // download() {
    // 	console.log(this.apk);
    // 	this.$global.download(this.apk);
    // },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;

    img {
      width: 200px;
      height: 200px;
    }

    .right {
      align-items: center;
      padding: 20px;
      justify-content: center;

      h1 {
        color: #4e7b44;
        font-weight: 700;
        max-width: 35vw;
      }
    }
  }
}

@media screen and (orientation: portrait) {
  .label {
    display: flex;
    white-space: nowrap;
    flex-wrap: wrap;
    align-items: center;
  }

  h1 {
    color: #4e7b44;
    font-weight: 700;
  }

  .top {
    span {
      margin-top: 10px;
    }

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  img {
    width: 200px;
    height: 200px;
  }

  .right {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.download-content {
  margin: 1rem auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.download-header {
  text-align: center;
  margin-bottom: 40px;
}

.download-header h1 {
  color: #0066cc;
  font-size: 2.5em;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
}

.download-header p {
  font-size: 1.1em;
  line-height: 1.6;
  color: #495057;
  max-width: 600px;
  margin: 0 auto;
}

.download-description {
  margin: 40px 0;
}

.download-description p {
  font-size: 1.1em;
  line-height: 1.7;
  color: #495057;
  max-width: 80%;
  margin: 0 auto;
}

.download-image {
  width: 100%;
  max-width: 600px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.download-button-section {
  text-align: center;
  margin: 40px 0;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #0066cc 0%, #004499 100%);
  color: white;
  border: none;
  padding: 18px 100px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 102, 204, 0.3);
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 102, 204, 0.4);
  background: linear-gradient(135deg, #004499 0%, #003366 100%);
}

.download-btn img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.app-info-section {
  margin: 40px 0;
}

.app-info-section h2 {
  color: #0066cc;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
}

.app-info-table {
  background: #f8f9fa;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  width: 80%;
  margin: 0 auto;
}

.app-info-table table {
  width: 100%;
  border-collapse: collapse;
}

.app-info-table th,
.app-info-table td {
  padding: 16px 20px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.app-info-table th {
  background: #e6f3ff;
  color: #0066cc;
  font-weight: 600;
  width: 40%;
}

.app-info-table tr:last-child td,
.app-info-table tr:last-child th {
  border-bottom: none;
}

.download-instructions {
  margin: 40px 0;
}

.download-instructions h2 {
  color: #0066cc;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
}

.download-instructions ol {
  background: #f8f9fa;
  padding: 30px 40px;
  border-radius: 12px;
  border-left: 4px solid #0066cc;
}

.download-instructions li {
  margin-bottom: 15px;
  line-height: 1.6;
  font-size: 16px;
}

.download-instructions li:last-child {
  margin-bottom: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .download-content {
    padding: 20px 15px;
  }

  .download-header h1 {
    font-size: 2em;
  }

  .download-header p {
    font-size: 1em;
  }

  .download-description p {
    font-size: 1em;
  }

  .download-btn {
    padding: 15px 25px;
    font-size: 16px;
  }

  .download-btn img {
    width: 20px;
    height: 20px;
  }

  .app-info-table th,
  .app-info-table td {
    padding: 12px 15px;
    font-size: 14px;
  }

  .download-instructions ol {
    padding: 20px 25px;
  }

  .download-instructions li {
    font-size: 14px;
  }
}
</style>
